module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/september-a7707274119deb80a6edbd3b64fb34ef.png";